/**
 * @file Identity selection modal.
 */

import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import withModal from '../modal/withModal';
import IdentitySelectList from './IdentitySelectList';

const propTypes = {
  identities: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string,
      last_name: PropTypes.string,
      current_photo: PropTypes.shape({
        id: PropTypes.string,
        thumbnail_urls: PropTypes.arrayOf(
          PropTypes.shape({
            url: PropTypes.string,
          }),
        ),
      }),
    }),
  ),
  onIdentitySelect: PropTypes.func.isRequired,
  selectedIdentityIds: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  itemClassName: PropTypes.string,
  renderItemChild: PropTypes.func,
  forceOpen: PropTypes.bool,
  onClose: PropTypes.func,
  onRequestClose: PropTypes.func,
  renderHeader: PropTypes.func,
  renderFooter: PropTypes.func,
};

const IdentitySelectListModal = ({
  forceOpen,
  onClose,
  renderHeader,
  renderFooter,
  onRequestClose,
  ...props
}) => {
  return (
    <Fragment>
      {renderHeader && renderHeader()}

      <div className="modal-overflow-scroll">
        <IdentitySelectList {...props} />
      </div>

      {renderFooter && renderFooter(onRequestClose)}
    </Fragment>
  );
};

IdentitySelectListModal.propTypes = propTypes;

export default withModal(IdentitySelectListModal, {
  dismissible: false,
  hideHeader: true,
  size: 'sm',
  className: 'modal-mobile-optimized',
});
